// 统计
import * as activity from 'activityConfigES';
import $ from 'jquery';
import '../lib/swiper';
import '../scss/swiper.scss';
import './scroll';
import './reserve';
import './share';
import './lottery';
import './bag';
import './game';
import * as base from './base';
import * as fb from './fb';
import * as dataReport from './dataReport';
import './fullpage';
import '../img/ico.png';
import '../img/share.jpg';
import { checkReserveStatus } from './reserve';
export const state = {
  music: true,
  menu: false,
};
const initEvent = () => {
  $('.j-close,.j-mask').on('click', function () {
    $('.j-popup,.j-mobile-menu').fadeOut(500);
  });
  $('.j-lottery-close, .j-lottery-mask').on('click', function () {
    $('.j-lottery-popup').fadeOut(500);
  });
  $('.j-screenshot-close, .j-screenshot-mask').on('click', function () {
    $('.j-screenshot-popup').fadeOut(500);
  });
  $('.j-chat-board-close').on('click', function () {
    $('.j-chat-board').fadeOut(500);
  });
  $('.j-tips-close').on('click', function () {
    $('.j-tips-popup').fadeOut(500);
  });
  $('.j-openBoard').on('click', function () {
    $('.j-chat-board').fadeIn(500);
  });
  $('.j-fb-share').on('click', async function () {
    await fb.fbShare();
  });
  $('.j-refresh-game').on('click', function () {
    $('.j-game-iframe').attr(
      'src',
      'https://gevents.blancozone.com/lifeRestart2/index.html'
    );
  });
  $('.j-copyright').on('click', () => {
    $('.j-footer').toggleClass('active');
  });
  $('.j-nav-wrap').on('click', () => {
    state.menu = !state.menu;
    $('.nav-show').toggleClass('show');
  });
  $('.j-fixed-lottery,.j-nav-lottery').on('click', () => {
    $('.j-lottery-popup').fadeIn(500);
  });
  $('.j-fixed-reserve,.j-reserve-btn').on('click', () => {
    checkReserveStatus()
      ? $('.j-finished-popup').fadeIn(500)
      : $('.j-reserve-popup').fadeIn(500);
  });
  $('.j-rule').on('click', () => {
    $('.j-rule-popup').fadeIn(500);
  });
  $('.j-audio-icon').on('click', ({ currentTarget }) => {
    $(currentTarget).toggleClass('pause');
    state.music = !state.music;
    state.music
      ? $('.j-music-audio')[0].play()
      : $('.j-music-audio')[0].pause();
  });
  $('.j-head-menu').on('click', () => {
    $('.j-mobile-menu').fadeIn(500);
  });
  $('.j-youtube-video').on('click', ({ currentTarget }) => {
    const videoId = currentTarget.dataset.id;
    if (!videoId.length) return;
    $('.j-video-wrapper').html(
      `<iframe width="100%" height="100%" src="https://www.youtube.com/embed/${videoId}?rel=0&playsinline=1&showinfo=0&disablekb=1&autoplay=1&modestbranding=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
    );
    state.music && $('.j-music-audio')[0].pause();
    $('.j-video-popup').fadeIn(500);
  });
  $('.j-video-close').on('click', () => {
    $('.j-video-wrapper').html('');
    !$('.j-audio-icon').hasClass('pause') && $('.j-music-audio')[0].play();
  });
};
export const init = async () => {
  activity.stat();
  dataReport.initReport();
  await base.initPage(true);
  // !checkReserveStatus() && setTimeout(() => {
  //   $('.j-reserve-popup').fadeIn(500);
  // },800)
  initEvent();
};
